export const gray1 = '#152235';
export const gray2 = '#475262';
export const gray5 = '#DBDFE5';
export const gray6 = '#ECEEF1';
export const gray7 = '#F3F5F9';
export const blue500 = '#1E55EB';



// WEBPACK FOOTER //
// ./assets/js/styles/Const.ts